export const TELEMED_JITSI_CONFIG = {
  prejoinPageEnabled: true,
  prejoinConfig: { enabled: true, showHangUp: true },
  toolbarButtons: ["microphone", "camera", "toggle-camera", "hangup"],
};

export const TELEMED_DOCTOR_JITSI_CONFIG = {
  ...TELEMED_JITSI_CONFIG,
  startWithAudioMuted: false,
  disableThirdPartyRequests: true,
  prejoinConfig: {
    ...TELEMED_JITSI_CONFIG.prejoinConfig,
    hideDisplayName: true,
  },
};
